import React, {useState, useEffect, use} from "react";
import { Modal, Button, Input, Col, Row } from "antd";
import { SelectCustomPiloto } from "./selectComponentPiloto";
import { manejarError } from "../manejo_errores";
import axios from "axios";
import { InputCustom } from "./inputComponent";
import { HeadersAuth } from "../funciones_utiles";
import { FilePdfOutlined } from "@ant-design/icons";

const ModalInvitado = ({
  open, 
  onCancel, 
  idPiloto,
  pilotos,
  datosPiloto,
  idCategoriaSeleccionada,
  idCarreraSeleccionada,
  manejarAlertas,
  onCambios,
  idAsociacion,
}) => {
  const [pilotoNombre, setPilotoNombre] = useState([]);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    id_piloto: "",
  });
  const [tempDatosFormularioNuevo, setTempDatosFormularioNuevo] = useState({
    id_piloto: "",
    dni: "",
    nombre: "",
    apellido: "",
    fecha_nacimiento: ""
  });
  const [data, setData] = useState(null);
  const [datosInvit, setDatosInvit] = useState([]);
  const [mostrarExistente, setMostrarExistente] = useState(false);
  const [mostrarNuevo, setMostrarNuevo] = useState(false);
  const [licenciaFrente, setLicenciaFrente] = useState("");
  const [licenciaDorso, setLicenciaDorso] = useState("");
  const [licenciaPdf, setLicenciaPdf] = useState("");

  const [previewLicenciaFrente, setPreviewLicenciaFrente] = useState("");
  const [previewLicenciaDorso, setPreviewLicenciaDorso] = useState("");
  const [previewLicenciaPdf, setPreviewLicenciaPdf] = useState("");
  const [licenciaExistente, setLicenciaExistente] = useState(null);
  const [idCampeonatoLicencia, setIdCampeonatoLicencia] = useState(null);

  useEffect(() => {
    setMostrarExistente(false);
    setTempDatosFormulario({
      id_pilotoInvitado: "",
    });
    setMostrarNuevo(false);
    
  }, [open, onCambios])

  // console.log("Piloto", pilotos)
  // console.log("datos", datosPiloto)
  useEffect(() => {
    if (idPiloto) {
      const pilotoDatos = datosPiloto.find(
        (p) => Number(p.id_piloto) === Number(idPiloto)
      );
      const idCampeonato = pilotoDatos?.carrera?.id_campeonato || null;
      setIdCampeonatoLicencia(idCampeonato);
      // console.log("datos", pilotoDatos)
      const pilotoInvit = pilotoDatos.pilotoInvitado; // objeto invitado
      // console.log("datosInvit", pilotoInvit)
      if (pilotoInvit !== null) {
        const pilotoAsignado =
          (pilotoInvit.nombre || []) + " " + (pilotoInvit.apellido || []);
        // console.log("data", pilotoAsignado)
        setDatosInvit(pilotoAsignado);
      }
      // console.log("piloto invitado", pilotoInvit)
      setData(pilotoInvit);

      const piloto = datosPiloto.map(i => i.piloto).find(p => Number(p.id) === Number(idPiloto));
      const pilotoCompleto = piloto?.nombre + " " + piloto?.apellido
      setPilotoNombre(pilotoCompleto || null);
      // console.log("pil", pilotoCompleto);
    }
  }, [idPiloto, pilotos, datosPiloto, open]);

  const asignarInvitado = async () => {
    try {
      let licencia_deportiva = null;

      if (licenciaPdf) {
        licencia_deportiva = {
          tipo_licencia: "PDF",
          licencia_pdf: licenciaPdf,
        };
      }

      if (licenciaFrente && licenciaDorso) {
        licencia_deportiva = {
          tipo_licencia: "IMAGENES",
          foto_frente: licenciaFrente,
          foto_dorso: licenciaDorso,
        };
      }

      const payload = {
        id_piloto: parseInt(idPiloto),
        id_piloto_invitado: parseInt(
          tempDatosFormulario.id_pilotoInvitado
        ),
        id_categoria: parseInt(idCategoriaSeleccionada),
        id_carrera: parseInt(idCarreraSeleccionada),
        id_asociacion: parseInt(idAsociacion),
        licencia_deportiva,
      };

      await axios.post(
        `${process.env.REACT_APP_DOMINIO}/asignar-invitado`,
        payload,
        HeadersAuth
      );

      manejarAlertas(
        "success",
        "Se ha asignado al piloto exitosamente."
      );

      setTempDatosFormulario({
        id_pilotoInvitado: "",
      });

      setLicenciaFrente("");
      setLicenciaDorso("");
      setLicenciaPdf("");

      setPreviewLicenciaFrente("");
      setPreviewLicenciaDorso("");
      setPreviewLicenciaPdf("");

      setMostrarNuevo(false);
      setMostrarExistente(false);

      onCambios();
      onCancel();
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const desasignarInvitado = async () => {
    try {
      const payload = {
        id_piloto: parseInt(idPiloto),
        id_piloto_invitado: parseInt(data.id),
        id_categoria: parseInt(idCategoriaSeleccionada),
        id_carrera: parseInt(idCarreraSeleccionada),
      };
      // console.log("lo que se envía des", payload)
      await axios.post(`${process.env.REACT_APP_DOMINIO}/desasignar-invitado`, payload, HeadersAuth);
      manejarAlertas("success","Se ha desasignado al piloto exitosamente.");
      setTempDatosFormulario({
        id_pilotoInvitado: "",
      });
      onCancel();
      onCambios();
      setMostrarNuevo(false);
      setMostrarExistente(false);
    } catch (error) {
      manejarAlertas("error",manejarError(error));
    }
  };

  const obtenerLicenciaInvitado = async (idInvitado) => {
    try {
      if (!idInvitado || !idAsociacion || !idCampeonatoLicencia) return;

      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/licencias-deportivas/${idInvitado}/${idAsociacion}/${idCampeonatoLicencia}`,
        HeadersAuth
      );

      setLicenciaExistente(response.data.licencia || null);
    } catch (error) {
      setLicenciaExistente(null);
    }
  };

  const asignarNuevo = async () => {
    try {
      let licencia_deportiva = null;

      if (licenciaPdf) {
        licencia_deportiva = {
          tipo_licencia: "PDF",
          licencia_pdf: licenciaPdf,
        };
      }

      if (licenciaFrente && licenciaDorso) {
        licencia_deportiva = {
          tipo_licencia: "IMAGENES",
          foto_frente: licenciaFrente,
          foto_dorso: licenciaDorso,
        };
      }

      const payload = {
        id_piloto: parseInt(idPiloto),
        id_categoria: parseInt(idCategoriaSeleccionada),
        id_carrera: parseInt(idCarreraSeleccionada),
        dni: tempDatosFormularioNuevo.dni,
        nombre: tempDatosFormularioNuevo.nombre,
        apellido: tempDatosFormularioNuevo.apellido,
        fecha_nacimiento: tempDatosFormularioNuevo.fecha_nacimiento,
        licencia_deportiva,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/asignar-invitado-nuevo`,
        payload,
        HeadersAuth
      );

      if (response.status === 200) {
        manejarAlertas("success", "Se ha asignado al piloto exitosamente.");

        setTempDatosFormularioNuevo({
          id_piloto: "",
          dni: "",
          nombre: "",
          apellido: "",
          fecha_nacimiento: "",
        });

        limpiarLicencia();

        setMostrarNuevo(false);
        setMostrarExistente(false);

        onCambios();
        onCancel();
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleLicenciaImageChange = (e, lado) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      manejarAlertas("error", "Solo se permiten imágenes JPG, JPEG o PNG.");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64 = reader.result;

      if (lado === "frente") {
        setLicenciaFrente(base64);
        setPreviewLicenciaFrente(base64);
      }

      if (lado === "dorso") {
        setLicenciaDorso(base64);
        setPreviewLicenciaDorso(base64);
      }

      setLicenciaPdf("");
      setPreviewLicenciaPdf("");
    };

    reader.readAsDataURL(file);
  };

  const handleLicenciaPdfChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      manejarAlertas("error", "El archivo debe ser PDF.");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setLicenciaPdf(reader.result);
      setPreviewLicenciaPdf(URL.createObjectURL(file));

      setLicenciaFrente("");
      setLicenciaDorso("");
      setPreviewLicenciaFrente("");
      setPreviewLicenciaDorso("");
    };

    reader.readAsDataURL(file);
  };
  
  const limpiarLicencia = () => {
    setLicenciaFrente("");
    setLicenciaDorso("");
    setLicenciaPdf("");
    setPreviewLicenciaFrente("");
    setPreviewLicenciaDorso("");
    setPreviewLicenciaPdf("");
  };

  useEffect(() => {
    setMostrarExistente(false);
    setTempDatosFormulario({
      id_pilotoInvitado: "",
    });
    setMostrarNuevo(false);
    limpiarLicencia();
  }, [open, onCambios]);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));

    if (id === "id_pilotoInvitado" && value) {
      obtenerLicenciaInvitado(value);
    }
  };

  const getUrlLicenciaInvitado = (licencia, archivo) => {
    if (!licencia || !archivo) return null;

    return `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${licencia.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${licencia.id_campeonato}/piloto_${licencia.id_piloto}/${archivo}`;
  };

  const handleChangeNuevo = (e) => {
    const { id, value } = e.target;
    setTempDatosFormularioNuevo((prev) => ({
      ...prev,
      [id]: value,
    }));
  }

  const handleMostrarExistente = () => {
    setMostrarExistente(!mostrarExistente);
    setMostrarNuevo(false);
  }

  const handleMostrarNuevo = () => {
    setMostrarNuevo(!mostrarNuevo);
    setMostrarExistente(false);
  }

  const stylesLicenciaWeb = {
    botonImagen: {
      display: "flex",
      width: "100%",
      height: 36,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#233463",
      color: "#fff",
      borderRadius: 6,
      cursor: "pointer",
      fontSize: 14,
      fontWeight: 600,
      marginTop: 8,
    },
    previewImagen: {
      width: "100%",
      height: 150,
      objectFit: "cover",
      borderRadius: 8,
      border: "1px solid #d5d5d5",
      marginTop: 10,
    },
    previewPdf: {
      flexDirection: "column",
      marginTop: 12,
      border: "1px solid #d5d5d5",
      borderRadius: 8,
      padding: 12,
      display: "flex",
      alignItems: "center",
      backgroundColor: "#fff",
    },
  };
  
  return (
    <Modal
      title={`Invitado de ${pilotoNombre}`}
      open={open}
      onCancel={onCancel}
      width={600}
      footer={null}
    >
      {mostrarExistente && (
        <Row
          gutter={16}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Col xs={24} sm={16}>
            <SelectCustomPiloto
              idCampo={"id_pilotoInvitado"}
              nombreCampo={"Pilotos para invitar"}
              elPlaceholder={"Seleccioná un piloto para invitar"}
              arrayOpciones={pilotos?.length > 0 ? pilotos : []}
              textoOpciones={"Nombre"}
              required={true}
              onChange={handleChange}
              elValue={tempDatosFormulario.id_pilotoInvitado}
            />
          </Col>

          {licenciaExistente && (
            <div
              style={{
                border: "1px solid #d5d5d5",
                borderRadius: 8,
                padding: 12,
                marginBottom: 15,
                marginTop: 20, 
                backgroundColor: "#fff",
              }}
            >
              <p style={{ fontWeight: 600, color: "#16803C", marginBottom: 10 }}>
                Este piloto ya tiene licencia cargada
              </p>

              {licenciaExistente.tipo_archivo === "PDF" ? (
                <Button
                  href={getUrlLicenciaInvitado(
                    licenciaExistente,
                    licenciaExistente.licencia_pdf
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={stylesLicenciaWeb.botonImagen}
                >
                  Ver PDF cargado
                </Button>
              ) : (
                <Row gutter={16}>
                  <Col xs={24} sm={12}>
                    <img
                      src={getUrlLicenciaInvitado(
                        licenciaExistente,
                        licenciaExistente.foto_frente
                      )}
                      alt="Frente licencia"
                      style={stylesLicenciaWeb.previewImagen}
                    />
                  </Col>

                  <Col xs={24} sm={12}>
                    <img
                      src={getUrlLicenciaInvitado(
                        licenciaExistente,
                        licenciaExistente.foto_dorso
                      )}
                      alt="Dorso licencia"
                      style={stylesLicenciaWeb.previewImagen}
                    />
                  </Col>
                </Row>
              )}

              <p style={{ color: "#777", fontSize: 13, marginTop: 10, marginBottom: 0 }}>
                Si cargás una nueva licencia, se actualizará la existente. Si no cargás nada,
                se mantendrá la actual.
              </p>
            </div>
          )}

          <Col xs={24}>
            <div
              style={{
                border: "1px solid #d5d5d5",
                borderRadius: 10,
                padding: 15,
                marginTop: 15,
                backgroundColor: "#fafafa",
              }}
            >
              <h3 style={{ color: "#233463", marginBottom: 6 }}>
                Licencia médica del invitado
              </h3>

              <p style={{ color: "#777", fontSize: 13, marginBottom: 12 }}>
                Podés cargar frente/dorso o un PDF. Si el invitado ya tiene licencia,
                podés dejarla como está o cargar una nueva para actualizarla.
              </p>

              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <label
                    style={stylesLicenciaWeb.botonImagen}
                    htmlFor="licencia-frente-web"
                  >
                    Seleccionar frente
                  </label>

                  <input
                    id="licencia-frente-web"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => handleLicenciaImageChange(e, "frente")}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaFrente && (
                    <img
                      src={previewLicenciaFrente}
                      alt="Frente licencia"
                      style={stylesLicenciaWeb.previewImagen}
                    />
                  )}
                </Col>

                <Col xs={24} sm={12}>
                  <label
                    style={stylesLicenciaWeb.botonImagen}
                    htmlFor="licencia-dorso-web"
                  >
                    Seleccionar dorso
                  </label>

                  <input
                    id="licencia-dorso-web"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => handleLicenciaImageChange(e, "dorso")}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaDorso && (
                    <img
                      src={previewLicenciaDorso}
                      alt="Dorso licencia"
                      style={stylesLicenciaWeb.previewImagen}
                    />
                  )}
                </Col>

                <Col xs={24}>
                  <label
                    style={{
                      ...stylesLicenciaWeb.botonImagen,
                      backgroundColor: "#BA1721",
                      marginTop: 12,
                    }}
                    htmlFor="licencia-pdf-web"
                  >
                    Seleccionar PDF
                  </label>

                  <input
                    id="licencia-pdf-web"
                    type="file"
                    accept="application/pdf"
                    onChange={handleLicenciaPdfChange}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaPdf && (
                    <div style={stylesLicenciaWeb.previewPdf}>
                      <FilePdfOutlined
                        style={{ fontSize: 34, color: "#BA1721" }}
                      />

                      <Button
                        href={previewLicenciaPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={stylesLicenciaWeb.botonImagen}
                      >
                        Ver PDF seleccionado
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Col>

          <Col xs={24}>
            <Button
              style={{
                width: "100%",
                backgroundColor: "#BA1721",
                color: "#fff",
                fontSize: 16,
                marginTop: 20,
              }}
              onClick={asignarInvitado}
            >
              Asignar piloto
            </Button>
          </Col>
        </Row>
    )}
      {mostrarNuevo && (
        <>
        <Row
          gutter={16}
          style={{ marginBottom: 15 }}
        >
          <Col xs={24} sm={12}>
            <InputCustom
              tipo="number"
              nombreCampo="DNI"
              idCampo="dni"
              elPlaceholder="Ingrese su DNI"
              elValue={tempDatosFormularioNuevo.dni}
              onChange={handleChangeNuevo}
              required={true}
            />
          </Col>
          <Col xs={24} sm={12}>
            <InputCustom
              nombreCampo="Nombre"
              idCampo="nombre"
              elPlaceholder="Ingrese su nombre"
              elValue={tempDatosFormularioNuevo.nombre}
              onChange={handleChangeNuevo}
              required={true}
            />
          </Col>
        </Row>
        <Row
          gutter={16}
        >
          <Col xs={24} sm={12}>
            <InputCustom
              nombreCampo="Apellido"
              idCampo="apellido"
              elPlaceholder="Ingrese su apellido"
              elValue={tempDatosFormularioNuevo.apellido}
              onChange={handleChangeNuevo}
              required={true}
            />
          </Col>
          <Col xs={24} sm={12}>
            <InputCustom
              idCampo="fecha_nacimiento"
              nombreCampo="Fecha de Nacimiento"
              tipo="date"
              elValue={tempDatosFormularioNuevo.fecha_nacimiento || ""}
              required
              onChange={handleChangeNuevo}
            />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24}>
            <div
              style={{
                border: "1px solid #d5d5d5",
                borderRadius: 10,
                padding: 15,
                marginTop: 15,
                backgroundColor: "#fafafa",
              }}
            >
              <h3 style={{ color: "#233463", marginBottom: 6 }}>
                Licencia médica del invitado
              </h3>

              <p style={{ color: "#777", fontSize: 13, marginBottom: 12 }}>
                Podés cargar frente/dorso o un PDF para el nuevo invitado.
              </p>

              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <label
                    style={stylesLicenciaWeb.botonImagen}
                    htmlFor="licencia-frente-nuevo-web"
                  >
                    Seleccionar frente
                  </label>

                  <input
                    id="licencia-frente-nuevo-web"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => handleLicenciaImageChange(e, "frente")}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaFrente && (
                    <img
                      src={previewLicenciaFrente}
                      alt="Frente licencia"
                      style={stylesLicenciaWeb.previewImagen}
                    />
                  )}
                </Col>

                <Col xs={24} sm={12}>
                  <label
                    style={stylesLicenciaWeb.botonImagen}
                    htmlFor="licencia-dorso-nuevo-web"
                  >
                    Seleccionar dorso
                  </label>

                  <input
                    id="licencia-dorso-nuevo-web"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => handleLicenciaImageChange(e, "dorso")}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaDorso && (
                    <img
                      src={previewLicenciaDorso}
                      alt="Dorso licencia"
                      style={stylesLicenciaWeb.previewImagen}
                    />
                  )}
                </Col>

                <Col xs={24}>
                  <label
                    style={{
                      ...stylesLicenciaWeb.botonImagen,
                      backgroundColor: "#BA1721",
                      marginTop: 12,
                    }}
                    htmlFor="licencia-pdf-nuevo-web"
                  >
                    Seleccionar PDF
                  </label>

                  <input
                    id="licencia-pdf-nuevo-web"
                    type="file"
                    accept="application/pdf"
                    onChange={handleLicenciaPdfChange}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaPdf && (
                    <div style={stylesLicenciaWeb.previewPdf}>
                      <FilePdfOutlined style={{ fontSize: 34, color: "#BA1721" }} />

                      <Button
                        href={previewLicenciaPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={stylesLicenciaWeb.botonImagen}
                      >
                        Ver PDF seleccionado
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
          <Col xs={24} sm={24}>
            <Button
              style={{
                width: "100%",
                backgroundColor: "#233463",
                color: "#fff",
                fontSize: 16,
                marginTop: 20
              }}
              onClick={asignarNuevo}
            >
              Asignar nuevo
            </Button>
          </Col>
        </Row>
        </>
      )}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 10
        }}
      >
        {data !== null ? (
          <div 
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-evenly",
              marginTop: 20,
              width: "100%",
            }}
          >
            <p>
              {datosInvit}
            </p>
            <Button
              style={{
                backgroundColor: "#233463",
                color: "#fff",
                fontSize: 14,
              }}
              onClick={desasignarInvitado}
            >
              Desasignar
            </Button>
          </div>
        ) : (
          <>
            {!mostrarExistente && (
              <Button
                style={{
                  width: "100%",
                  backgroundColor: "#fff",
                  color: "#BA1721",
                  borderColor: "#BA1721",
                  border: "1px solid #BA1721",
                  fontSize: 16,
                  marginTop: 10
                }}
                onClick={handleMostrarExistente}
              >
                Asignar invitado existente
              </Button>
            )}
            {!mostrarNuevo && (
              <Button
                style={{
                  width: "100%",
                  backgroundColor: "#fff",
                  color: "#233463",
                  borderColor: "#233463",
                  border: "1px solid #233463",
                  fontSize: 16,
                  marginTop: 10
                }}
                onClick={handleMostrarNuevo}
              >
                Asignar invitado nuevo
              </Button>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default ModalInvitado;